/* assets/route-validation.js.liquid */
(function(window, document) {
  'use strict';
  window.SDG = window.SDG || {};
  
  SDG.routeValidation = function(lastStateVal, next) {
    var canProceed = window.store &&
      window.store.state &&
      window.store.state.fitFinder &&
      window.store.state.fitFinder.data &&
      window.store.state.fitFinder.data[lastStateVal];
    if (!canProceed) { next('/usage'); }
    else { next(); }
  };

})(window, document);
